jQuery.fn.extend({
	menuToggle: function (options = {}) {
		return this.each(function () {
			var
				$this = $(this),
				$target = $($this.data('target'));

			$target.addClass('hidden');

			$this
				.addClass('target-hidden')
				.on('click', function () {
					$this.toggleClass('active', $target.is(':hidden'))
					
					$target.slideToggle(function () {
						$this
							.toggleClass('target-hidden', $target.is(':hidden'))
							.toggleClass('target-visible', $target.is(':visible'));

						$target
							.toggleClass('hidden', $target.is(':hidden'))
							.css('display', '');
					});
				});
		});
	}
});



// WEBPACK FOOTER //
// ./assets/js/components/extensions/jquery.menuToggle.js